import { combineReducers } from 'redux';

import { createReducer } from '../../../utils';
import constant from './constant';

const listHandlers = {
    [constant.TASKLISTGET](state, action) {
        return action.payload;
    },
};

const provincelistHandlers = {
    [constant.PROVINCELINST](state, action) {
        return action.payload;
    },
};

const labellistHandlers = {
    [constant.LABELLINST](state, action) {
        return action.payload;
    },
};
const moniterNameListHandlers = {
    [constant.MONITERNAMELIST](state, action) {
        return action.payload;
    },
}
const curvelistHandlers = {
    [constant.CURVELINST](state, action) {
        return action.payload;
    },
};

const clusterlistHandlers = {
    [constant.CLUSTERLINST](state, action) {
        return action.payload;
    },
};

const outTaskCategoryListHandlers = {
    [constant.OUTTASKCATEGORYLIST](state, action) {
        return action.payload;
    },
};

const grouplistHandlers = {
    [constant.GROUPLIST](state, action) {
        return action.payload;
    },
};

const agentsHandlers = {
    [constant.AGENTS](state, action) {
        return action.payload;
    }
};
const areasHandlers = {
    [constant.AREAS](state, action) {
        return action.payload;
    }
};

const stateHandlers = {
    // 所有状态
    [constant.LISTLOADING](state, action) {
        return { ...state, loading: action.payload };
    },
    [constant.PAGETOTAL](state, action) {
        return { ...state, pageTotal: action.payload };
    },
    [constant.ADDSHOW](state, action) {
        return { ...state, addShow: action.payload };
    },
    [constant.EDITSHOW](state, action) {
        return { ...state, editShow: action.payload };
    },
    [constant.ADDTYPE](state, action) {
        return { ...state, addType: action.payload };
    },
    [constant.RESETPVSHOW](state, action) {
        return { ...state, resetPvShow: action.payload };
    },
    [constant.BULKUPDATETASK](state, action) {
        return { ...state, bulkupdatetask: action.payload };
    },
    [constant.TASKOVERFLOWSTATU](state, action) {
        return { ...state, taskOverFlowStatu: action.payload };
    },
    [constant.TASKOVERFLODINGSTATU](state, action) {
        return { ...state, taskOverFlowStatuLoding: action.payload };
    },
};

const taskIdHandlers = {
    [constant.GETTASKID](state, action) {
        return action.payload;
    },
};
const setTaskIdHandlers = {
    [constant.TASKID](state, action) {
        return action.payload;
    },
};
const setTaskIdListHandlers = {
    [constant.TASKIDLIST](state, action) {
        return action.payload;
    },
};
const parentIdHandlers = {
    [constant.GETPARENTID](state, action) {
        return action.payload;
    },
};
const rootHandlers = {
    [constant.GETROOT](state, action) {
        return action.payload;
    },
};

const taskHandlers = {
    [constant.GETTASK](state, action) {
        return action.payload;
    },
};

const primaryScriptHandlers = {
    [constant.PRIMRYSCRIPT](state, action) {
        return action.payload;
    }
};
const otherScriptHandlers = {
    [constant.OTHERSCRIPT](state, action) {
        return action.payload;
    }
};
const PvHandlers = {
    [constant.GETPV](state, action) {
        return action.payload;
    }
};
const EditInfoHandlers = {
    [constant.EDITINFO](state, action) {
        return action.payload;
    },
    [constant.EDITIME](state, action) {
        return { ...state, filtration: action.payload };
    },
    [constant.EDITOVERFLOW](state, action) {
        return { ...state, overflowRate: action.payload };
    },
    [constant.EDITIPREUSEDTIMES](state, action) {
        return { ...state, ipReusedTimes: action.payload };
    },
    [constant.EDITTASKTYPE](state, action) {
        return { ...state, taskType: action.payload };
    },
    [constant.EDITANDROIDRATIO](state, action) {
        return { ...state, androidRatio: action.payload };
    },
    [constant.EDITENGINE](state, action) {
        return { ...state, engine: action.payload };
    },
    [constant.EDITPVTOUVRATIO](state, action) {
        return { ...state, pvToUvRatio: action.payload };
    },
    [constant.EDITFORCEWAIT](state, action) {
        return { ...state, forceWait: action.payload };
    },
    [constant.MAINSCRIPT](state, action) {
        return { ...state, mainScriptPath: action.payload };
    },
    [constant.SCRIPT](state, action) {
        return { ...state, scriptPath: action.payload };
    },
    [constant.EDITWAITTIMEOUT](state, action) {
        return { ...state, waitTimeout: action.payload };
    },
    [constant.EDITPROVINCE](state, action) {
        return { ...state, provinces: action.payload };
    },
    [constant.TASKSOURCE](state, action) {
        return { ...state, taskSource: action.payload };
    },
    [constant.TRACKDELAYTIME](state, action) {
        return { ...state, trackDelayTime: action.payload };
    },
    [constant.TASKPOSITION](state, action) {
        return { ...state, taskPosition: action.payload };
    },
    [constant.TIMEPAIRS](state, action) {
        return { ...state, timePairs: action.payload };
    },
    [constant.CHANGE](state, action) {
        return {...state, ...action.payload};
    }
};
const screenShowHandlers = {
    [constant.SCREENSHOTSHOW](state, action) {
        return { ...state, isShowScreen: action.payload };
    }
};

const apiShowHandlers = {
    [constant.SHOWAPI](state, action) {
        return { ...state, ...action.payload };
    },
};

const printTaskItemData = {
    [constant.PRINTTASKITEMDATA](state, action) {
        return action.payload;
    }
};
const userlistHandlers = {
    [constant.USERLIST](state, action) {
        return action.payload;
    }
};
const accountListHandlers = {
    [constant.ACCOUNTLIST](state, action) {
        return action.payload;
    }
};
const tasklogsHandlers = {
    [constant.TASKLOGS](state, action) {
        return { ...state, list: action.payload };
    },
    [constant.SHOWMODAL](state, action) {
        return { ...state,  showModal: action.payload};
    },
    [constant.HIDEMODAL](state, action) {
        return { ...state,  showModal: action.payload};
    },
    [constant.SHOWDETAIL](state, action) {
        return { ...state, showDetail: action.payload};
    },
    [constant.HIDEDETAIL](state, action) {
        return { ...state, showDetail: action.payload};
    },
    [constant.TASKLOGBYINDEX](state, action) {
        return { ...state, tasklogByIndex: action.payload};
    },
};
const taskNoteHandlers = {
    [constant.TASKNOTE](state, action) {
        return { ...state, taskNote: action.payload };
    },
    [constant.SHOWTASKNOTE](state, action) {
        return { ...state, showTaskNoteModel: action.payload};
    },
    [constant.HIDETASKNOTE](state, action) {
        return { ...state, showTaskNoteModel: action.payload};
    },
};


export const List = createReducer([], listHandlers); // 活动列表
export const ProvinceList = createReducer([], provincelistHandlers);
export const LabelList = createReducer([], labellistHandlers);
export const moniterNameList = createReducer([], moniterNameListHandlers);
export const curveList = createReducer([], curvelistHandlers);
export const ClusterList = createReducer([], clusterlistHandlers);
export const OutTaskCategoryList = createReducer([], outTaskCategoryListHandlers);
export const GroupList = createReducer([], grouplistHandlers);
export const UserList = createReducer([], userlistHandlers);
export const ListStatus = createReducer(
    { taskOverFlowStatuLoding:false,loading: false, pageTotal: '0', addShow: false, editShow: false, addType: 1 ,resetPvShow:false,bulkupdatetask:false,taskOverFlowStatu:false},
    stateHandlers,
); // 所有状态
export const taskId = createReducer(0, setTaskIdHandlers);//设置弹层传递的taskId
export const taskIdList = createReducer([], setTaskIdListHandlers);//设置弹层传递的taskIdList
export const TaskId = createReducer(0, taskIdHandlers);
export const ParentId = createReducer(0, parentIdHandlers);
export const Root = createReducer({}, rootHandlers);
export const Task = createReducer({}, taskHandlers);
export const EditInfo = createReducer({}, EditInfoHandlers);
export const primaryScripts = createReducer([], primaryScriptHandlers);
export const otherScripts = createReducer([], otherScriptHandlers);
export const pvCount = createReducer([], PvHandlers);
export const agents = createReducer([], agentsHandlers);
export const areas = createReducer([], areasHandlers);

export const screenShow = createReducer({ isShowScreen: false }, screenShowHandlers);
export const apiShow = createReducer({ isShowApi: false, taskId: '', url: '' }, apiShowHandlers);
export const printTaskData = createReducer({}, printTaskItemData);

export const tasklogs = createReducer({showModal: false, list: [], showDetail: false, tasklogByIndex: ''}, tasklogsHandlers);

export const taskNotes = createReducer({taskNote:{},showTaskNoteModel:false},taskNoteHandlers);
export const accountList = createReducer([],accountListHandlers);
export const tasklist = combineReducers({
    UserList,
    Task,
    agents,
    areas,
    GroupList,
    ClusterList,
    OutTaskCategoryList,
    taskId,
    pvCount,
    ProvinceList,
    LabelList,
    curveList,
    List,
    ListStatus,
    TaskId,
    ParentId,
    EditInfo,
    Root,
    primaryScripts,
    otherScripts,
    taskIdList,
    screenShow,
    printTaskData,
    apiShow,
    tasklogs,
    taskNotes,
    moniterNameList,
    accountList,
});



// WEBPACK FOOTER //
// ./pages/task/tasklist/reducers.js